import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'
import { INVITATION_CHANNEL_TITLE, invitationChannelUnitPriceLabel } from '@app/v2/event/utils/invitation-channel-ui.util'
import { InvitationChannel } from '@app/v2/event/utils/invitation-channel-status.util'
import { ModalComponent } from '@app/v2/shared/components/modal/modal.component'
const BULK_SEND_CONFIRM_UNIT_NOUN: Record<InvitationChannel, { singular: string; plural: string }> = {
  email: { singular: 'email', plural: 'emails' },
  whatsapp: { singular: 'message', plural: 'messages' },
  sms: { singular: 'message', plural: 'messages' }
}

@Component({
  selector: 'app-bulk-send-confirm-modal',
  standalone: true,
  imports: [ModalComponent],
  templateUrl: './bulk-send-confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BulkSendConfirmModalComponent {
  public readonly id = input.required<string>()
  public readonly channel = input.required<InvitationChannel>()
  public readonly recipientCount = input.required<number>()
  public readonly unitPriceUsd = input.required<number>()
  public readonly totalCostUsd = input.required<number>()
  public readonly isSending = input(false)

  public readonly confirmed = output<void>()
  public readonly back = output<void>()
  public readonly cancelled = output<void>()

  public readonly infoIconSrc = 'assets/images/v2/bulk-send-confirm/info.svg'

  public readonly header = computed(() => `Send invitations via ${INVITATION_CHANNEL_TITLE[this.channel()]}`)

  public readonly unitNoun = computed(() => BULK_SEND_CONFIRM_UNIT_NOUN[this.channel()])

  public readonly recipientCountLabel = computed(() => this.recipientCount().toLocaleString())

  public readonly recipientLabel = computed(() => `${this.recipientCountLabel()} ${this.recipientCount() === 1 ? 'attendee' : 'attendees'}`)

  public readonly unitPriceLabel = computed(() => invitationChannelUnitPriceLabel(this.unitPriceUsd()))

  public readonly totalCostLabel = computed(() => invitationChannelUnitPriceLabel(this.totalCostUsd()))

  public readonly confirmLabel = computed(() => (this.isSending() ? 'Sending…' : 'Yes, send'))

  /**
   * Requests the send; the parent keeps the modal open until the API responds.
   */
  public onConfirm(): void {
    if (this.isSending()) return
    this.confirmed.emit()
  }

  /**
   * Back button: asks the parent to return to channel selection without sending.
   */
  public onBack(): void {
    if (this.isSending()) return
    this.back.emit()
  }

  /**
   * Handles dismiss from the header X (backdrop / Escape are disabled while sending).
   */
  public onModalClose(): void {
    this.cancelled.emit()
  }
}
